export const colorOptions = [
    { label: 'Blanco', value: '#FFFFFF', displayColor: '#FFFFFF' },
    { label: 'Negro', value: '#000000', displayColor: '#000000' },
    { label: 'Gris Plata', value: '#D1D1D1', displayColor: '#D1D1D1' },
    { label: 'Gris Oscuro', value: '#6D6D6D', displayColor: '#6D6D6D' },
    { label: 'Azul Oscuro', value: '#0062FF', displayColor: '#0062FF' },
    { label: 'Rojo', value: '#FF3B2B', displayColor: '#FF3B2B' },
    { label: 'Bordó', value: '#9E132B', displayColor: '#9E132B' },
    { label: 'Verde', value: '#71CB56', displayColor: '#71CB56' },
    { label: 'Amarillo', value: '#FFCD61', displayColor: '#FFCD61' },
  ];
  